import React, {Component} from 'react';
import {Status, StatusMsg} from '../utils/status';
import {formatMoney} from '../utils/common';
import classNames from 'classnames';

export const Transaction = React.memo(({value, newOrder}) => {
    var noteBold = "";
    var note = value.note;
    if (value.status === Status.PENDING) {
        note = "ZaloPay đang chờ đối soát với ngân hàng và sẽ hoàn tiền lại cho khách hàng trong vòng 3-5 ngày làm việc.";
    } else if (value.status === Status.FAILED) {
        note = "ZaloPay đang chờ đối soát với ngân hàng và sẽ hoàn tiền lại cho khách hàng trong vòng 3-5 ngày làm việc.";
        if (value.revert_time.length > 0) {
            noteBold = value.revert_time;
            note = "ZaloPay đã hoàn tiền cho khách hàng vào ";
        }
    }
    return (
        <tr className={classNames("animated",{
            "bounceInRight": newOrder,
            "fast": newOrder
        })}>
            <td>
                <div className="cell-date">{value.date}</div>
                <div className={classNames("hidden-amount",{
                    ok : value.status === Status.SUCCESS,
                    failed: value.status === Status.FAILED,
                    pending: value.status === Status.PENDING,
                })}>{formatMoney(value.money,0,"") + " VNĐ"}</div>
            </td>
            <td className="text-center">
                <div className="cell-title">Mã gd Merchant</div>
                <div className="cell-data">{value.app_trans_id}</div>
            </td>
            <td className="text-center">
                <div className="cell-title">Mã gd ZaloPay</div>
                <div className="cell-data">{value.zp_trans_id} </div>
            </td>

            <td className="amount text-right">
				<div className={classNames("cell-data",{
                    ok : value.status === Status.SUCCESS,
                    failed: value.status === Status.FAILED,
                    pending: value.status === Status.PENDING,
                })}>{formatMoney(value.money,0,"") + " VNĐ"}</div>
			</td>

            <td className="text-center">
                <div className="cell-title">Trạng thái</div>
                <div className={classNames("cell-data",{
                    status_ok: value.status === Status.SUCCESS,
                    status_failed: value.status === Status.FAILED,
                    status_pending: value.status === Status.PENDING,
                })}>{StatusMsg[value.status]}</div>
            </td>
            <td className="notes">
                <div className="cell-title">Ghi chú</div>
                <div className="cell-data">{note}<b>{noteBold}</b></div>
            </td>
        </tr>        
    );
});

export const TransactionTable = React.memo((props) => {
    return (
        <div className="responsive-full-wrap">
            <table className="table w-100 transactions">
                <thead>
                    <tr>
                        <th width="180">THỜI ĐIỂM</th>
                        <th width="280" className="text-center">MÃ GD MERCHANT</th>
                        <th width="180" className="text-center">MÃ GD ZALOPAY</th>
                        <th width="150" className="text-right">SỐ TIỀN</th>
                        <th width="200" className="text-center">TÌNH TRẠNG</th>
                        <th>GHI CHÚ</th>
                    </tr>
                </thead>
                <tbody>
                    {props.children}
                </tbody>
            </table>
        </div>
    )
});